require('./dist/ng-file-upload-all');
module.exports = 'ngFileUpload';


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-file-upload/index.js
// module id = 454
// module chunks = 6